import { TrackingService } from 'sharebase/services/trackingService';

export let TrackFormSubmissionDirective = function(sbTrackingService:TrackingService): ng.IDirective {
    return {
        restrict: 'A',
        link: ($scope, element, attrs) => {
            let formName = element.attr("name");
            if(!angular.isDefined(formName)) {
                throw new Error('The form must have a name in order to be tracked.');
            }

            //If given a name, the form object is placed on the scope automatically
            //Since we use the controllerAs syntax, the form object will be nested (i.e. vm.someFormName)
            let form = formName.split('.')
                               .reduce((obj, i) => {
                                   return obj[i];
                                }, $scope);
            if(!angular.isDefined(form)) {
                throw new Error('The form object was not found on the scope and will not be tracked.');
            }

            let trackInvalidFormSubmissions = attrs.sbTrackInvalidFormSubmissions as boolean;
            let formValue = {};

            element.on('submit', submitForm);
            
            function submitForm() {
                //If we want to track form fields, loop through the form's inputs and find
                //ones with the sb-track-form-field property
                form.$$controls.forEach(element => {
                    if(element.$$attr["sbTrackFormField"] != null) {
                        formValue[element.$name] = element.$modelValue;
                    }
                });

                if(form.$valid) {
                    sbTrackingService.trackFormSubmission(formName, JSON.stringify(formValue));
                }
                else if(trackInvalidFormSubmissions) {
                    sbTrackingService.trackFormSubmission(formName, JSON.stringify(formValue), 0);
                }
            }

            $scope.$on('$destroy',function(){
                element.off('submit', submitForm);
            });
        }
    };
}
TrackFormSubmissionDirective.$inject = [
    'sbTrackingService'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/trackFormSubmission/trackFormSubmission.ts